export default __webpack_public_path__ + "static/6858-83c164f16e53b1de9482b8a6c705b3f3.jpg";